import React from "react";
import {
  FormContainer,
  RadioButtonGroup,
  TextFieldElement,
} from "react-hook-form-mui";
import { useTranslation } from "react-i18next";

type FormProps = {
  boxHeight: number;
  boxWidth: number;
  boxWeight: number;
  returnable: string;
  fragile: string;
};

const AdditionalDetails = ({
  step,
  setStep,
  formData,
  setFormData,
  finalSubmit,
}: any) => {

  const {t} = useTranslation()

  const defaultValues: FormProps = {
    boxHeight: undefined,
    boxWidth: undefined,
    boxWeight: undefined,
    returnable: "Yes",
    fragile: "Yes",
  };

  const onSubmit = (values: FormProps) => {
    console.log(values);
    finalSubmit(values);
  };

  return (
    <div className="w-full flex flex-col gap-6 py-4 ">
      <h6 className="text-[#23282D] poppins text-2xl font-medium leading-9 tracking-tight">
       {t('adminRoute.createProductPage.additionalDetails.additionalDetailsTitle')}
      </h6>
      <FormContainer defaultValues={defaultValues} onSuccess={onSubmit}>
        <div className="flex flex-col gap-8 w-full">
          <div className="w-full grid grid-cols-3 gap-16 ">
            <div className="w-full flex flex-col gap-1">
              <TextFieldElement
                name="boxHeight"
                placeholder={t('adminRoute.createProductPage.additionalDetails.height')}
                required
                fullWidth
              />
            </div>
            <div className="w-full flex flex-col gap-1">
              <TextFieldElement
                name="boxWidth"
                placeholder={t('adminRoute.createProductPage.additionalDetails.width')}
                required
                fullWidth
              />
            </div>
            <div className="w-full flex flex-col gap-1">
              <TextFieldElement
                name="boxWeight"
                placeholder={t('adminRoute.createProductPage.additionalDetails.weight')}
                required
                fullWidth
              />
            </div>
          </div>
          <div className="w-full flex gap-8 items-center">
            <h6 className="text-[#23282D] poppins text-2xl font-medium leading-9 tracking-tight">
            {t('adminRoute.createProductPage.additionalDetails.returnable.label')}
            </h6>
            <RadioButtonGroup
              name="returnable"
              options={[
                {
                  id: "Yes",
                  label: t('adminRoute.createProductPage.additionalDetails.returnable.options.yes'),
                },
                {
                  id: "No",
                  label: t('adminRoute.createProductPage.additionalDetails.returnable.options.no'),
                },
              ]}
              row
            />
          </div>
          <div className="w-full flex gap-8 items-center">
            <h6 className="text-[#23282D] poppins text-2xl font-medium leading-9 tracking-tight">
              {t('adminRoute.createProductPage.additionalDetails.fragile.label')}
            </h6>
            <RadioButtonGroup
              name="fragile"
              options={[
                {
                  id: "Yes",
                  label: t('adminRoute.createProductPage.additionalDetails.fragile.options.yes'),
                },
                {
                  id: "No",
                  label: t('adminRoute.createProductPage.additionalDetails.fragile.options.no'),
                },
              ]}
              row
            />
          </div>
          <button
            className="rounded bg-primary py-2 px-16 poppins text-white w-fit "
            type="submit"
          >
          {t('adminRoute.createProductPage.additionalDetails.continueButton')}
          </button>
        </div>
      </FormContainer>
    </div>
  );
};

export default AdditionalDetails;
